export default "__VITE_ASSET__CBDa$QmL__"